"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createSetItemField_1 = require("./utils/createSetItemField");
var itemChange_1 = require("owa-service/lib/factory/itemChange");
var itemId_1 = require("owa-service/lib/factory/itemId");
var updateItemRequest_1 = require("owa-service/lib/factory/updateItemRequest");
var updateItemOperation_1 = require("owa-service/lib/operation/updateItemOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
function createRequestBody(itemIds, flagStatus) {
    var update = createSetItemField_1.default('Flag', { FlagStatus: flagStatus });
    var itemChanges = [];
    itemIds.forEach(function (id) {
        return itemChanges.push(itemChange_1.default({
            Updates: [update],
            ItemId: itemId_1.default({ Id: id }),
        }));
    });
    return updateItemRequest_1.default({
        ItemChanges: itemChanges,
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
    });
}
function flagItemService(itemIds, flagStatus) {
    var requestBody = createRequestBody(itemIds, flagStatus);
    return updateItemOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = flagItemService;
//# sourceMappingURL=flagItemService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-store/lib/services/flagItemService.js
// module id = 5587
// module chunks = 62